import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class ExerciseStoreAPI extends BaseAPI {}

export default new ExerciseStoreAPI('v1/exercise-stores', 'ExerciseStore')
